import {html, type TemplateResult} from 'lit';

export function footer(site: string, gdprUrl: string, externalEmbedSettings: string): TemplateResult {
  const videoSites = ['sky', 'eurosport', 'youtube'];
  const contentType = videoSites.includes(site) ? 'Videos' : 'Inhalte';

  return html`
  <div class="externalembed__footer-wrapper">
  <div class="externalembed__optin-toggle">
  <label class="switch animate">
     <input type="checkbox">
     <span class="toggle">
       <span class="ball"></span>
     </span>
   </label>
   Externe ${contentType} anzeigen
</div>
<h4 class="externalembed__text externalembed__dataschutz">
<a href="${gdprUrl}">Datenschutzerklärung</a> und <a href="${externalEmbedSettings}">Zustimmungen zu externen Inhalten</a>
</h4>
  </div>
  `;
}
